import React from 'react';
import { useEffect, useMemo } from 'react';
import { environment } from '../config/firebase.config';

const EnvironmentBanner = React.memo(({ zoomLevel = null }) => {
  // Memoize expensive calculations that don't change during app lifecycle
  const bannerConfig = useMemo(() => {
    const hostname = window.location.hostname;

    // Check for Vercel development deployments (without https:// and trailing slashes)
    const isVercelDev = hostname === 'realworld-sightseer-react-userlingers-projects.vercel.app'
      || hostname === 'realworld-sightseer-react-git-dev-userlingers-projects.vercel.app';

    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

    // Check for local network IPs (for mobile device testing)
    const isLocalNetworkIP = (
      /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
      /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
      /^172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}$/.test(hostname)
    );

    const bannerText = isVercelDev
      ? '🚧 DEV BRANCH'
      : isLocalNetworkIP
      ? `🚧 LOCAL NETWORK`
      : '🚧 LOCAL DEVELOPMENT - Using emulators and test data';

    const backgroundColor = isVercelDev ? '#2196F3' : '#ff9800'; // Blue for Vercel, Orange for local

    return {
      hostname,
      isVercelDev,
      isLocalhost,
      isLocalNetworkIP,
      bannerText,
      backgroundColor
    };
  }, []); // Empty deps - these values never change during app lifecycle

  // Debug logging - only run once on mount
  useEffect(() => {
    if (environment === 'development') {
      console.log(`[EnvironmentBanner] Hostname: "${bannerConfig.hostname}"`);
      console.log(`[EnvironmentBanner] Environment: ${environment}`);
      console.log(`[EnvironmentBanner] isVercelDev: ${bannerConfig.isVercelDev}`);
      console.log(`[EnvironmentBanner] isLocalhost: ${bannerConfig.isLocalhost}`);
      console.log(`[EnvironmentBanner] isLocalNetworkIP: ${bannerConfig.isLocalNetworkIP}`);
    }
  }, []); // Empty dependency array means this only runs on mount

  // Only show banner in development environment
  if (environment !== 'development') {
    return null;
  }

  const zoomText = Number.isFinite(zoomLevel)
    ? ` | Zoom: ${Number(zoomLevel).toFixed(0)}`
    : '';

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: bannerConfig.backgroundColor,
      color: '#fff',
      padding: '4px 8px',
      textAlign: 'center',
      fontSize: '12px',
      fontWeight: 'bold',
      zIndex: 10000,
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
    }}>
      {bannerConfig.bannerText}{zoomText}
    </div>
  );
});

EnvironmentBanner.displayName = 'EnvironmentBanner';

export default EnvironmentBanner;
